module.exports = __webpack_public_path__ + "img/effects-16.415db8a5.png";